// extracted by mini-css-extract-plugin
module.exports = {"actions":"_18023","price":"_8224","current":"_10708","cost":"_10725","value":"_7569","buy":"_10742","disabled":"_11713"};